<script setup>
import { ref, onMounted } from "vue";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import TabBar from "@/components/TabBar.vue";

const route = useRoute();
const showTabBar = computed(() => route.meta.showTabBar ?? false);

const userStore = useUserStore();
const isInitComplete = ref(false);

console.log(import.meta.env.VITE_APP_TITLE); // "开发环境"
console.log(import.meta.env.VITE_APP_BASE_URL); // "localhost:3000"
console.log(import.meta.env.VITE_API_BASE_URL); // "localhost:3000"
console.log(import.meta.env.MODE); // "development"
console.log(import.meta.env.DEV); // true
console.log(import.meta.env.PROD);

onMounted(async () => {
  await userStore.init();
  isInitComplete.value = true;
});

// 监听路由变化
watch(
  () => route.path,
  () => {
    const appContainer = document.getElementById("app");
    appContainer?.scrollTo(0, 0);
  }
);
</script>

<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <TabBar v-if="showTabBar" />
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
